<template>
    <div class="footer flex-center mt-2">
        <button class="btn btn-primary btn-round" @click="$emit('click')">
            <slot></slot>
        </button>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>

</style>
